import create from "zustand";

const useBranchStore = create((set) => ({
  isListChanged: false,
  refreshBranchList: () =>
    set((state) => ({ isListChanged: !state.isListChanged })),
}));

export default useBranchStore;
